var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUTurnRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0915 20.7526C17.5071 21.1162 18.1389 21.0741 18.5026 20.6585L22.0026 16.6585C22.3325 16.2815 22.3325 15.7185 22.0026 15.3415L18.5026 11.3415C18.1389 10.9258 17.5071 10.8837 17.0915 11.2474C16.6759 11.6111 16.6337 12.2429 16.9974 12.6585L19.0462 15H9.25C6.48858 15 4.25 12.7614 4.25 10C4.25 7.23857 6.48858 5 9.25 5H17.75C18.3023 5 18.75 4.55228 18.75 4C18.75 3.44771 18.3023 3 17.75 3H9.25C5.38401 3 2.25 6.134 2.25 10C2.25 13.866 5.38401 17 9.25 17H19.0462L16.9974 19.3415C16.6337 19.7571 16.6759 20.3889 17.0915 20.7526Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUTurnRight);
export default __webpack_public_path__ + "static/media/arrow_u_turn_right.8d9371a93981910fcaca742c4a79b6b9.svg";
export { ForwardRef as ReactComponent };